import Referral from '@/assets/icons/referral.svg?react'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import clsx from 'clsx'
import { InviteReferralModal } from './InviteReferralModal'

export const InviteReferralButton = ({ collapseMobile }: { collapseMobile?: boolean }) => {
  return (
    <InviteReferralModal
      dialogTrigger={
        <Tooltip>
          <TooltipTrigger>
            <Button variant="tertiary" size="small">
              <span className="flex items-center gap-2">
                <Referral width={20} height={20} />
                <span className={clsx(collapseMobile && 'max-mobile:hidden')}>Get Referral Link</span>
              </span>
            </Button>
          </TooltipTrigger>
          <TooltipContent
            align="end"
            className="flex max-w-[490px] gap-6 border border-solid !border-gray-100 !bg-[var(--colorBlackToWhite)] p-4 py-5"
          >
            <img src="/images/ref-tooltip.png" width={104} height={104} />
            <div className="text-[var(--colorWhiteToBlack)]">
              When someone signs up using your referral link, they’ll receive a special welcome benefit, and you’ll earn
              exclusive rewards for each successful referral.
            </div>
          </TooltipContent>
        </Tooltip>
      }
    />
  )
}
